define(function(require, exports, module) {
    'use strict';

    const CommonLookupView = require('common/addressLookupSwiss/lookupControls/commonLookupView');
    const StreetNameProvider = require('common/addressLookupSwiss/sourceProviders/streetNameProvider');

    module.exports = CommonLookupView.extend({
        controlType: 'streetName',

        SourceProvider: StreetNameProvider,

        update: function(model) {
            const changed = model.changed;
            const controlType = model.get('controlType');

            if (controlType === 'zipCity' && changed.selectedItem) {
                this.model.set({
                    hidden: false,
                    prevSearchResult: changed.selectedItem
                });

                this.$el.find('.fn-lookup-input-text')[0].focus();
            }
        },

        /**
         * @override
         * @returns {string}
         */
        getValidationError: function() {
            return 'playtech.mobile.registration.addressLookupSwiss.streetName.validation';
        }
    });
});
